import { Button, FormControl, FormLabel, HStack, Input, Stack, Text } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { SignatureCanvas, SignatureCanvasHandle } from './SignatureCanvas';

interface Props {
  onSubmit: (data: { emailCode: string; signatureImage: string }) => void;
}

export function ContractStepSign({ onSubmit }: Props) {
  const [emailCode, setEmailCode] = useState('');
  const [signatureValid, setSignatureValid] = useState(false);
  const [signatureImage, setSignatureImage] = useState('');
  const canvasRef = useRef<SignatureCanvasHandle>(null);

  const codeValid = /^\d{6}$/.test(emailCode);
  const canSubmit = codeValid && signatureValid && signatureImage;

  return (
    <Stack spacing={4}>
      <FormControl isRequired>
        <FormLabel>Código de 6 dígitos</FormLabel>
        <Input
          value={emailCode}
          onChange={(e) => setEmailCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          maxLength={6}
          inputMode="numeric"
        />
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Assinatura</FormLabel>
        <SignatureCanvas
          ref={canvasRef}
          onChange={(dataUrl, valid) => {
            setSignatureImage(dataUrl);
            setSignatureValid(valid);
          }}
        />
        {!signatureValid && signatureImage && (
          <Text color="orange.500" fontSize="sm" mt={1}>
            Faça uma assinatura mais visível (mais traços, área maior)
          </Text>
        )}
      </FormControl>

      <HStack justify="flex-end">
        <Button colorScheme="blue" isDisabled={!canSubmit} onClick={() => onSubmit({ emailCode, signatureImage })}>
          Continuar
        </Button>
      </HStack>
    </Stack>
  );
}
